import Blue from "~/core";

new Blue({
  name: 'Youtube Video Embed',
  selector: ".media-embed--youtube",
  setup(video) {
    const youtubeId = video.getAttribute('data-id')
    const videoInner = video.querySelector('.media-embed__video')
    const videoFrame = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>`
    let thumbnail
    if(!video.classList.contains('media-embed--youtube-custom')) {
      thumbnail = `<img class="media-embed__thumbnail" src="//i.ytimg.com/vi_webp/${youtubeId}/maxresdefault.webp" alt="Youtube Preview"><button class="media-embed__play"></button>`;
      videoInner.insertAdjacentHTML('afterbegin', thumbnail)
    } else {
      thumbnail = video.querySelector('media-embed__thumbnail')
    }    
    this.$addEvents(videoInner.children[1], 'click', function() {
      videoInner.innerHTML = videoFrame
    })
    // videoInner.children[1].addEventListener('click', function() {
    //     videoInner.innerHTML = videoFrame
    // })
  }
});


new Blue({
  name: 'Media Video Embed',
  selector: ".media-embed--video",
  setup(video) {
    const videoInner = video.querySelector('.media-embed__video')
    const playButton = `<button class="media-embed__play is-active"></button>`
    
    // Event listener for the play/pause button
    video.insertAdjacentHTML('afterbegin', playButton)
    const play = video.querySelector('.media-embed__play')
    this.$addEvents(play, 'click', function() {
      if (videoInner.paused == true) {
        videoInner.play()
        toggleControls (videoInner, video)
      } else {
        // here to catch weird outliers
        videoInner.pause()
        toggleControls (videoInner, video)
      }
    })
    this.$addEvents(videoInner, 'pause', function() {
      // listen for pause but if the vid is over use default browser behavior
      if(!videoInner.ended)
        toggleControls (videoInner, video)
    })
    function toggleControls (vid, container) {
      vid.toggleAttribute('controls')
      container.classList.toggle('media-embed--is-playing')
    }
  }
});